/**
 * Favourite instruments: the client's first watchlist ("Favorites"), kept on the server so it follows
 * them across devices. Earlier favourites kept in this browser are moved there once (stores/markets.ts).
 */
import { useEffect } from 'react';
import { useStore } from '../lib/store';
import { loadWatchlists, marketsStore, toggleInWatchlist } from './markets';

const EMPTY: string[] = [];

export function toggleFavorite(symbol: string) {
  const first = marketsStore.get().watchlists?.[0];
  if (first) void toggleInWatchlist(first.id, symbol);
  else void loadWatchlists().then(() => toggleFavorite(symbol));
}

export function useFavorites(): string[] {
  useEffect(() => {
    void loadWatchlists();
  }, []);
  return useStore(marketsStore, (s) => s.watchlists?.[0]?.symbols ?? EMPTY);
}
